import { Container } from "./styles";
import Yarmouk from "../../assets/Yarmouk-University.jpg";

export function Education() {
  return (
    <Container id="education">
      <h2>My Education</h2>
      <div className="projects">
          <div className="project">
            <header>
              <img
                src={Yarmouk}
                alt="Yarmouk University Logo"
                className="logo"
              />
              <div className="header-text">
                <p className="university-name">Yarmouk University</p>
                <p className="major">Bachelor of Computer Science</p>
              </div>
              <div className="gpa">
                <p>GPA of 77.8</p>
              </div>
              <footer>
                <p>Earned on: August, 2018</p>
              </footer>
            </header>
          </div>
      </div>
    </Container>
  );
}
